export const upsellingHc = {
  servicios: {
    accommodation: "Unterkunft",
    all: "Alle",
    state: "Status",
    search: "Suchen",
    searchPlaceholder: "Gast oder Buchungscode…",
    from: "Von",
    to: "Bis",
    today: "Heute",
    noDate: "Kein Datum",
    clear: "Zurücksetzen",
    thService: "Service",
    thGuest: "Gast",
    thBooking: "Buchung",
    thRequested: "Angefragt",
    statusConsult: "Auf Anfrage",
    statusRejected: "Abgelehnt",
    statusPaid: "Bezahlt",
    statusPartial: "Teilzahlung",
    statusApproved: "Bestätigt",
    statusPending: "Ausstehend",
    serviceFallback: "Service",
    openBookingTitle: "Buchung öffnen",
    approve: "Bestätigen",
    reject: "Ablehnen",
    viewBooking: "Buchung ansehen",
    noRecords: "Keine Einträge",
    noRecordsFiltered: "Mit den gesetzten Filtern wurden keine Einträge gefunden.",
    noRequestsYet: "Sobald ein Gast einen Service anfragt, erscheint er hier.",
    chipBreakfast: "Frühstück",
    chipTour: "Tour",
    chipTransport: "Transfer",
    chipMore: "Und was immer Sie anbieten",
    approveTitle: "Anfrage bestätigen",
    amountLabel: "Zu berechnender Betrag",
    amountFree: "0 = keine Berechnung",
    amountHint: "Mit angebundenem Zahlungsanbieter erhält der Gast einen <strong>Zahlungslink</strong> (WhatsApp + E-Mail). Andernfalls wird ihm mitgeteilt, dass er <strong>bei Anreise zahlt</strong>.",
    cancel: "Abbrechen",
    processing: "Wird verarbeitet…",
    approveAndNotify: "Bestätigen und benachrichtigen",
    amountInvalid: "Geben Sie einen gültigen Betrag ein (0 = keine Berechnung).",
    approvedPaymentLink: "Bestätigt. Der Zahlungslink wurde an den Gast gesendet (WhatsApp + E-Mail).",
    approvedOnArrival: "Bestätigt. Der Gast zahlt bei Anreise (kein Zahlungsanbieter verbunden).",
    approvedNotified: "Bestätigt. Der Gast wurde benachrichtigt.",
    approveFailed: "Die Anfrage konnte nicht bestätigt werden.",
    rejectTitle: "Anfrage ablehnen",
    rejectMessage: "Wenn Sie ablehnen, wird dem Gast dieser Service NICHT berechnet und er wird benachrichtigt. Anfrage ablehnen?",
    rejected: "Anfrage abgelehnt. Der Gast wurde benachrichtigt.",
    rejectFailed: "Die Anfrage konnte nicht abgelehnt werden.",
  },
  form: {
    basicTitle: "Grundangaben",
    basicDesc: "Name und Beschreibung, die der Gast sieht.",
    autoTranslate: "Schreiben Sie es in <strong>Ihrer Sprache</strong>. Beim Speichern wird es <strong>automatisch</strong> in alle Sprachen übersetzt (Spanisch, Englisch, Portugiesisch, Französisch, Deutsch, Italienisch, Chinesisch und Arabisch); der Gast sieht seine eigene.",
    selectPlaceholder: "Auswählen…",
    catNightlife: "Nachtleben",
    subtitleLabel: "Untertitel",
    optional: "optional",
    subtitlePlaceholder: "Ein kurzer Aufhänger, z. B.: „Erleben Sie es selbst“",
    price: "Preis",
    priceDesc: "Wie dieser Service dem Gast berechnet wird.",
    segWithPrice: "Mit Preis",
    segWithPriceDesc: "Wird automatisch berechnet",
    segOnRequest: "Auf Anfrage",
    segOnRequestDesc: "Der Gast fragt, Sie erstellen ein Angebot",
    currencyLabel: "Währung",
    currencyHint: "die des Inserats",
    chargeBy: "Berechnung nach",
    unitPlaceholder: "Modus wählen…",
    unitPerUnit: "Pro Einheit (Festpreis)",
    unitPerPerson: "Pro Person (× Gäste)",
    unitPerNight: "Pro Nacht (× Nächte)",
    unitPerGroup: "Pro Gruppe / Aufenthalt",
    unitPerHour: "Pro Stunde",
    unitHintPerson: "Wird mit der Anzahl der Gäste in der Buchung multipliziert.",
    unitHintNight: "Wird mit der Anzahl der Nächte in der Buchung multipliziert.",
    unitHintUnit: "Festpreis für jede Einheit, die der Gast kauft.",
    unitHintGroup: "Einheitlicher Preis für die Buchung, unabhängig von Personen oder Nächten.",
    unitHintHour: "Preis pro gebuchter Stunde.",
    unitLabelPerson: "/ pro Person",
    unitLabelNight: "/ pro Nacht",
    unitLabelGroup: "/ pro Aufenthalt",
    unitLabelHour: "/ pro Stunde",
    stockControl: "Bestand verwalten",
    inventory: "Inventar",
    stockDesc: "Für Dinge, die ausgehen (z. B. ein Zustellbett oder Kinderbett): Begrenzen Sie die Einheiten. Sie werden mit jeder Buchung automatisch und in Echtzeit abgezogen.",
    unitsAvailable: "Verfügbare Einheiten",
    removeUnitAria: "Eine Einheit entfernen",
    addUnitAria: "Eine Einheit hinzufügen",
    stockNoteSoldOut: "Bei <strong>0</strong> Einheiten wird der Service als <strong>Ausverkauft</strong> angezeigt und kann nicht hinzugefügt werden.",
    stockNoteAuto: "Bei 0 wird automatisch <strong>Ausverkauft</strong> angezeigt.",
    stockConsumePerson: "Jede Buchung zieht 1 Einheit pro Gast ab.",
    stockConsumeNight: "Jede Buchung zieht 1 Einheit pro Nacht ab.",
    stockModeTitle: "So funktioniert der Bestand",
    stockModeAvail: "Nach Verfügbarkeit",
    stockModeAvailDesc: "Er ist nur während des Aufenthalts belegt und wird beim Check-out wieder frei (Kinderbett, Zustellbett).",
    stockModeProduct: "Nach Produkt",
    stockModeProductDesc: "Er wird mit jeder Buchung abgezogen und kommt nicht zurück. Sie füllen ihn manuell auf.",
    stockUnlimited: "Unbegrenzter Bestand: keine Mengenbegrenzung.",
    photosTitle: "Fotos",
    photoMain: "Hauptbild",
    makeMainTitle: "Als Hauptbild festlegen",
    removeTitle: "Entfernen",
    addPhoto: "Foto hinzufügen",
    addPhotos: "Fotos hinzufügen",
    reorderHint: "Ziehen zum Sortieren · das erste erscheint auf der Karte.",
    whereTitle: "Wo wird er angeboten?",
    whereDesc: "Inserate, in denen er verfügbar ist. Keine Auswahl = alle.",
    selected: "{count} ausgewählt",
    all: "Alle",
    none: "Keine",
    searchListingPlaceholder: "Inserat suchen…",
    noResults: "Keine Ergebnisse",
    diffCurrencyTitle: "Dieses Inserat verwendet {currency}. Ein Service hat nur eine Währung.",
    unit: "Einheit",
    units: "Einheiten",
    loadingListings: "Inserate werden geladen…",
    previewLabel: "Vorschau · so sieht es der Gast",
    previewPhoto: "Ihr Hauptbild",
    previewTitleFallback: "Name des Service",
    previewDescFallback: "Die Beschreibung, die Sie schreiben, erscheint hier, damit der Gast weiß, was enthalten ist.",
    free: "Kostenlos",
    soldOut: "Ausverkauft",
    add: "Hinzufügen",
    remaining: "Noch {count} Einheit | Noch {count} Einheiten",
    scopeManaged: "Wird in <strong>allen Ihren Inseraten</strong> angeboten. Welche, wählen Sie in der Liste Services und Erlebnisse.",
    scopeAll: "Verfügbar in <strong>allen Ihren Unterkünften</strong>",
    scopeSome: "Verfügbar in <strong>{count}</strong> Inserat | Verfügbar in <strong>{count}</strong> Inseraten",
    errNameRequired: "Der Name ist erforderlich",
    errCategoryRequired: "Die Kategorie ist erforderlich",
    errDescRequired: "Die Beschreibung ist erforderlich",
    errPriceRequired: "Geben Sie einen Preis ein (0, wenn er kostenlos ist).",
    errPriceNegative: "Der Preis darf nicht negativ sein.",
    errUnitRequired: "Wählen Sie, wie berechnet wird (Berechnung nach)",
    errStockRequired: "Geben Sie an, wie viele Einheiten auf Lager sind (0, wenn ausverkauft).",
    errProcessing: "Fehler bei der Verarbeitung der Anfrage.",
  },
  createServicio: {
    subtitle: "Füllen Sie die Angaben aus und verfolgen Sie die Vorschau in Echtzeit.",
    photosDesc: "Fügen Sie beliebig viele hinzu · das 1. ist das Hauptbild · JPG, PNG oder WebP.",
    imageRequired: "Laden Sie mindestens ein Bild hoch.",
  },
  updateServicio: {
    title: "Erlebnis oder Service bearbeiten",
    subtitle: "Aktualisieren Sie die Angaben und verfolgen Sie die Vorschau in Echtzeit.",
    loadingAria: "Service wird geladen",
    photosDesc: "Fügen Sie beliebig viele hinzu oder entfernen Sie sie · das 1. ist das Hauptbild · JPG, PNG oder WebP.",
    save: "Änderungen speichern",
    imageRequired: "Es muss mindestens ein Bild übrig bleiben.",
    loadFailed: "Der Service konnte nicht geladen werden.",
  },
  configUpselling: {
    title: "Cross-Selling-Einstellungen",
    phoneIntro: "Geben Sie die Telefonnummer ein, über die Sie Benachrichtigungen zu Serviceanfragen per WhatsApp erhalten möchten",
    saveWhatsapp: "WhatsApp speichern",
    editWhatsapp: "WhatsApp bearbeiten",
    mustEnterWhatsapp: "Sie müssen die WhatsApp-Nummer eingeben",
    swalTitle: "Cross-Selling per WhatsApp",
    swalText: "Sie erhalten alle Benachrichtigungen zu den von Kunden angefragten Services",
    cancel: "Abbrechen",
    addedSuccess: "WhatsApp erfolgreich hinzugefügt",
  },
};
